module.exports = __webpack_public_path__ + "static/media/perfect-gold_00006.cadec3c3.png";